import { staticRoutesWithCustomSidebar } from 'Deer/constants/staticRoutesWithCustomSidebar';
import { useParsedQuery } from 'components/hooks/useParsedQuery';
import { matchPath, useLocation } from 'react-router-dom';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { routes } from 'constants/routes';

export const useReviewPreviewParams = () => {
  const { isPreview, providerType } = useParsedQuery();
  return { isPreview: isPreview === 'true', providerType };
};

// this sends back the enum 'SUBMITTED' if the route is the result page
// ans 'IN_PROGRESS' if the route is the form page
// this is specifically for the purpose of the performance preview page api calls
export const useReviewPreviewPageStatus = () => {
  const { isPreview } = useReviewPreviewParams();
  const location = useLocation();
  const match = matchPath(location.pathname, {
    path: checkNewNavEnabled() ? staticRoutesWithCustomSidebar.reviewsResultPage : routes.performanceReview.result,
    exact: true,
  });

  if (!isPreview) {
    return undefined;
  }
  if (match) {
    return 'SUBMITTED';
  }
  return 'IN_PROGRESS';
};

export const useIsCurrentRouteReviewResultPage = () => {
  const { isPreview } = useReviewPreviewParams();
  const location = useLocation();
  const match = matchPath(location.pathname, {
    path: checkNewNavEnabled() ? staticRoutesWithCustomSidebar.reviewsResultPage : routes.performanceReview.result,
    exact: true,
  });

  if (!isPreview) {
    return undefined;
  }
  if (match) {
    return true;
  }
  return false;
};
